import React from 'react';
import moment from 'moment';
import { FontIcon } from 'material-ui';

export default class extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      day: moment().format('DD/MM'),
      hours: moment().format('HH:mm')
    };
  }
  componentDidMount() {
    this.timerID = setInterval(
      () => this.tick(),
      1000
    );
  }
  componentWillUnmount() {
    clearInterval(this.timerID);
  }
  tick() {
    this.setState({
      day: moment().format('DD/MM'),
      hours: moment().format('HH:mm')
    });
  }
  render() {
    return (
      <h4 style={{
        'paddingTop': '10px',
        'color': 'white'
      }}>
        <FontIcon style={{ color: 'white'}} className="fa fa-calendar"/> {this.state.day}{' '}{' '}
        <FontIcon style={{ color: 'white'}} className="fa fa-clock-o"/> {this.state.hours}
    </h4>
  );
}
}



// WEBPACK FOOTER //
// src/modules/general/components/clock.js